var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    stroke: "#08743B",
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 31.5h17a1 1 0 0 0 1-1V13.304L23.521 5.5H13a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1zm11.375-28 8.625 9v18a3 3 0 0 1-3 3H13a3 3 0 0 1-3-3v-24a3 3 0 0 1 3-3h11.375z",
    fill: "#1E7145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.5h2v9h8v2H22v-11z",
    fill: "#1E7145"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14.5v-10h1l8 8v2h-9z",
    fill: "#1E7145"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E7145",
    stroke: "{stroke}",
    strokeWidth: 2,
    d: "M4 11.566h15.071v13.933H4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 24h-3.526l-2.405-3.613L9.04 24H5.5l4.394-5.868L6.346 13h3.577l1.662 2.79 1.77-2.79h3.64l-3.719 5.132L17.5 24z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFile);
export default __webpack_public_path__ + "static/media/greenFile.0a595023e3978e2f0211af142a0a56a5.svg";
export { ForwardRef as ReactComponent };